import { computedFrom, autoinject } from 'aurelia-framework';
import {DialogController} from "aurelia-dialog";
import states from "../../models/state-list";
import { WebApiService } from '../../services/web-api-service';
import { BusyService } from "../../services/busy-service";

@autoinject
export class SelectLocationsDialog {
    constructor(
        protected controller: DialogController,
        private api: WebApiService,
        private busyService: BusyService
    ) {
        this.states = states;
        this.api = api;
    }

    states: Array<any>;
    products: Array<any> = [];

    //array of state codes to filter the divisions list
    nameFilter: string;
    selectedStates: Array<any> = [];
    selectedProducts: Array<any> = [];
    allDivisions: Array<any> = [];
    divisionProductXref: Array<any> = [];

    loadDivisions() {
        this.busyService.on();
        return this.api.get("Registration", "GetDivisions")
            .then((result) => {
                this.allDivisions = JSON.parse(result.response);
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    loadProducts() {
        this.busyService.on();
        return this.api.get("Registration", "GetProducts")
            .then((result) => {
                this.products = JSON.parse(result.response);
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    loadDivisionProductXref() {
        this.busyService.on();
        return this.api.get("Registration", "GetDivisionProductXref")
            .then((result) => {
                this.divisionProductXref = JSON.parse(result.response);
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    @computedFrom("allDivisions.length", "selectedStates.length", "selectedProducts.length", "nameFilter")
    get filteredDivisions(): Array<any> {
        let nameFilterLower = (this.nameFilter || "").toLowerCase();
        return this.allDivisions.filter((item) => {
            return (!nameFilterLower || item.name.toLowerCase().indexOf(nameFilterLower) > -1) && 
                (this.selectedStates.length == 0 || this.selectedStates.indexOf(item.state) > -1) &&
                (this.selectedProducts.length == 0 || this.divisionProductXref.find((xref) => {
                    return xref.divisionId == item.id && this.selectedProducts.indexOf(xref.productId) > -1;
                }));
        })
    }

    selectedDivisions: any = [];

    activate(divisionIds: Array<any>) {
        //because this dialog is recreated each time it is activated, 
        //  we have to load the main divisions list on each activation.
        // As a result, we need to populate the selectedDivisions array
        //  by correlating the divisions passed in with the objects in the 
        //  this.allDivisions array, so that the correct object reference is used.

        this.loadDivisions()
            .then(() => {
                for (var division of divisionIds) {
                    this.selectedDivisions.push(this.allDivisions.find((e) => e.id == division.id));
                }
            });

        this.loadDivisionProductXref();
        this.loadProducts();

    }

    cancel() {
        this.controller.cancel();
    }

    ok() {
        this.controller.ok(this.selectedDivisions.sort((a, b) => a.name > b.name));
    }
}